import React, { useState } from 'react'
import { Mail, ArrowRight, CheckCircle } from 'lucide-react'

const FinalCTA: React.FC = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return

    setIsLoading(true)
    setMessage('')

    try {
      const response = await fetch('https://newsletter-backend.dhkim79.workers.dev/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      })

      const data = await response.json()
      setMessage(data.message)
      
      if (data.success) {
        setEmail('')
      }
    } catch (error) {
      setMessage('구독 중 오류가 발생했습니다. 다시 시도해주세요.')
    } finally {
      setIsLoading(false)
    }
  }

  const benefits = [
    '무료 구독',
    '즉시 취소 가능',
    '30분 → 3분 요약'
  ]

  return (
    <section className="section-padding bg-gradient-to-br from-primary-600 to-primary-700">
      <div className="container-max">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            지금이 마지막 기회
          </h2>
          
          <p className="text-xl md:text-2xl mb-12 text-primary-100">
            매주 진짜 AI 트렌드를 받아보세요
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center justify-center space-x-3">
                <CheckCircle className="w-6 h-6 text-green-400" />
                <span className="text-lg font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1 relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="dkim@dkeducation.com"
                  className="w-full px-4 py-3 pl-12 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className="bg-white text-primary-600 hover:bg-gray-100 font-semibold py-3 px-6 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600 flex items-center justify-center gap-2 whitespace-nowrap"
              >
                {isLoading ? (
                  '구독 중...'
                ) : (
                  <>
                    무료 구독하기
                    <ArrowRight className="w-5 h-5" />
                  </>
                )}
              </button>
            </div>
            
            {message && (
              <p className={`mt-4 text-sm ${
                message.includes('완료') || message.includes('재활성화') 
                  ? 'text-green-300' 
                  : 'text-red-300'
              }`}>
                {message}
              </p>
            )}
          </form>

          <div className="mt-8 text-primary-100">
            <p>지금 구독하고 AI 트렌드의 최전선에 서세요</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinalCTA
